export default "__VITE_ASSET__5GokSqGe__"